import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Bike} from '../../models/bike';
import {BikeService} from '../../services/bike.service';
import {BikeType} from '../../models/bike-type.enum';
import {NgbModalRef, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BikesDeleteComponent} from '../bikes-delete/bikes-delete.component';
import {BikesFormComponent} from '../bikes-form/bikes-form.component';
import {BikeFilter} from '../../models/filters/bike-filter';
import { fadeInAndOut } from '../../utils/animations-utils';
import { AccountService } from '../../services/account.service';
import { Roles } from '../../models/roles';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bikes',
  animations: [fadeInAndOut()],
  templateUrl: './bikes-list.component.html',
  styleUrls: ['./bikes-list.component.css']
})
export class BikesListComponent implements OnInit {

  NAME_FILTER = "bike.name";
  TYPE_FILTER = "bike.type";
  LOCK_FILTER = "lock.id";
  CREATION_DATE_FILTER = "creationDate";
  LAST_COMM_FILTER = "lastCommunicationDate";
  STATE_FILTER = "bike.state";
  GRP_FILTER = "grp.name";
  STATION_FILTER = "station.name";
  DELETED_FILTER = "bike.deleted";

  CREATION_DATE_ORDER = "bike.creationDate";
  LAST_COMM_ORDER = "bike.lastCommunicationDate";
  BATTERYLEVEL_ORDER = "bike.batteryLevel";
  STATION_ORDER = "stationname";

  p: number = 1;      // current page
  total: number;      // total count of records
  itemsPerPage = environment.itemPerPage;       // number of records to display on each page
  listLoading : boolean;
  downloading: boolean = false;


  filters: Map<string, any>;
  typeFilter: string = "ALL";
  stateFilter: string = "ALL";
  listFiltered = false;

  /**
   * Keys : string criterias
   * Values : boolean => true if ascending, false otherwise
   */
  sortingCriterias: Map<string, boolean> = new Map();

  /** Bikes list to display on the table */
  bikes: Bike[];

  /** Update / delete bikes */
  bikeToDelete: Bike;

  /** Modals ref */
  deleteModal: NgbModalRef;
  formModal: NgbModalRef;

  isSuperAdmin : boolean;

  constructor(private bikeService: BikeService,
              private modalService: NgbModal,
              public accountService : AccountService,
              public toast : ToastsManager,
              public translate : TranslateService) {
  }

  ngOnInit() {
    this.initFilters();
    if (localStorage.getItem("itemsPerPage")) {
      this.itemsPerPage = parseInt(localStorage.getItem("itemsPerPage"))
    }

    this.getPage(1);
  }

  initFilters() {
    this.filters = new Map();
  }

  getPage(page: number) {
    this.p = page;
    this.listLoading = true;
    this.bikeService.getPaginatedFilteredSortedBikes(this.p, this.itemsPerPage, this.filters, this.sortingCriterias).subscribe(data => {
      this.bikes = data.res;
      this.total = data.headers.get("x-total-count");
      this.listLoading = false;
    });
  }

  reloadList() {
    this.listFiltered = false;
    Object.values(this.filters).forEach(value => {
      if (value) {
        this.listFiltered = true;
      }
    });
    this.getPage(1);
  }

  onTypeChange() {
    this.updateFilters();
    this.reloadList();
  }

  onStateChange() {
    this.updateFilters();
    this.reloadList();
  }

  /* ========== Filter, Sort, Pagination ============ */
  changeItemCount(value) {
    this.itemsPerPage = value;
    this.reloadList();

    localStorage.setItem("itemsPerPage", value);
  }

  updateSortingCriterias(criteria: string) {
    if (this.sortingCriterias.has(criteria)) {
      if (this.sortingCriterias.get(criteria)) {   // criteria is present as true => switch to false
        this.sortingCriterias.set(criteria, !this.sortingCriterias.get(criteria));
      } else {    // criteria present as false => delete it
        this.sortingCriterias.delete(criteria);
      }
    } else {
      this.sortingCriterias.set(criteria, true);
    }
  }

  sortBy(criteria: string) {
    this.updateSortingCriterias(criteria);
    this.updateFilters();  // take count of the last filters modifications
    this.reloadList();
  }

  clearFilters() {
    this.typeFilter = "ALL";
    this.stateFilter = "ALL";
    this.listFiltered = false;
    this.initFilters();
    this.reloadList();
  }

  updateFilters() {
    if (this.typeFilter == "ALL") {
      this.filters[this.TYPE_FILTER] = undefined;
    } else {
      this.filters[this.TYPE_FILTER] = this.typeFilter;
    }

    if (this.stateFilter == "ALL") {
      this.filters[this.STATE_FILTER] = undefined;
    } else {
      this.filters[this.STATE_FILTER] = this.stateFilter;
    }

  }


  /* ========== Modals ========== */
  /**
   * Display creation modal
   */
  onNewClick() {
    this.formModal = this.modalService.open(BikesFormComponent, {size: "lg", backdrop: "static"});
    this.formModal.componentInstance.creationMode = true;
  }

  onUpdateClick(bike: Bike) {
    /* Load additionnal data and display modal */
    this.bikeService.get(bike.id).subscribe(b => {
      this.formModal = this.modalService.open(BikesFormComponent, {size: "lg", backdrop: "static"});
      this.formModal.componentInstance.creationMode = false;
      this.formModal.componentInstance.bike = b
      this.formModal.componentInstance.bike.stationName = bike.stationName;

      this.formModal.componentInstance.onUpdateValidation.subscribe(result => {
        let i = this.bikes.indexOf(this.bikes.find(s => s.id == result.id));

        this.bikes[i] = result;
      });
    });
  }

  onDeleteClick(bike: Bike) {
    this.bikeToDelete = bike;
    this.deleteModal = this.modalService.open(BikesDeleteComponent, {centered: true});
    this.deleteModal.componentInstance.bike = this.bikeToDelete;
    this.deleteModal.componentInstance.onDeleteValidation.subscribe(deleted => this.apHasBeenDeleted(deleted));
  }

  apHasBeenDeleted(deleted: any) {
    // toast user
    this.toast.success(this.translate.instant("toast.bikedeleted"), this.translate.instant("toast.success"));
    this.reloadList();
  }

  downloadXLSFile() {
    this.downloading = true;
    this.bikeService.downloadXLSFile(
      this.p,
      this.itemsPerPage,
      this.filters,
      this.sortingCriterias)
      .subscribe(isTruncated => {
        if (isTruncated) {
          this.toast.warning(this.translate.instant('common.downloadOk'));
        } else {
          this.toast.success(this.translate.instant('common.downloadTruncated'));
        }
        this.downloading = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/bikes/bikes-list/bikes-list.component.ts